import {APIGateway, TIMEOUT_STRING} from "../common/constants";

const postMessagePromises = {};

function generateGuid() {
    /**
     * @return {string}
     */
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}

function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
    const newGuid = generateGuid();
    message.guid = newGuid;
    postMessagePromises[newGuid] = {};
    postMessagePromises[newGuid]['promise'] = new Promise(function (resolve, reject) {
        postMessagePromises[newGuid]['resolve'] = resolve;
        postMessagePromises[newGuid]['reject'] = reject;
        targetWindow.postMessage(message, targetOrigin);
        if (timeout) {
            setTimeout(() => {
                postMessagePromises[newGuid].resolve(TIMEOUT_STRING);
            },timeout);
        }
    });
    return postMessagePromises[newGuid].promise;
}

window.addEventListener("message", onNewPostMessageFromParent, false);

function onNewPostMessageFromParent(event) {
    if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
        subscribeAbleEvents[event.data.method](event.data);
    }
}

const subscribeAbleEvents = {
    "sendApiGatewayResponse": sendApiGatewayResponse,
    "sendCountryCodeResponse": sendResponse,
    "sendFeatureStatus": sendFeatureStatus
}

function sendApiGatewayResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendResponse(data) {
    console.log("Send response",data);
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendFeatureStatus(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

export async function getAPIGatewayDataFromParent(args) {
    console.log("API Gateway request : " + JSON.stringify(args));
    return await postMessagePromised(window.parent, {
        method: 'getAPIGatewayDataFromParent',
        args: args
    }, '*');
}

export function getAPIGatewayRequest(endpoint, request, httpMethod = "GET") {
    return {
        resourcePath: endpoint,
        httpMethod: httpMethod,
        processName: APIGateway.PROCESS_NAME,
        requestBody: request
    }
}

export async function getCountryCodeFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getCountryCode',
        args: {}
    }, '*',1000);
}

export async function fetchCountryCode() {
    const countryCodeResponse = await getCountryCodeFromParent();
    if (TIMEOUT_STRING === countryCodeResponse) {
        /*
         * Fallback when time out
         */
        return "";
    }
    const countryCode = JSON.parse(countryCodeResponse.locale);
    console.log("fetchCountryCode -> ",countryCode);
    return countryCode;
}

/**
 * This method will get the feature flag from AppConfig
 * @param {List<String>} features
 * @returns
 */
export async function getFeaturesFromParent(features) {
    return await postMessagePromised(window.parent, {
        method: 'getFeatureStatus',
        args: {features}
    }, '*')
}

export function publishClientSideMetrics(args) {
    window.parent.postMessage({
        method: 'publishClientSideMetrics',
        args: args
    }, "*");
}



// WEBPACK FOOTER //
// ./src/component/handler/ParentDataHandler.js